import React from 'react';
import  {withRouter} from 'react-router';
import axios from 'axios';
import Select from 'react-select';
import Textarea from 'react-textarea-autosize';
import 'react-select/dist/react-select.css';
import Chip from 'material-ui/Chip';

import DatePicker from 'react-datepicker';
import Checkbox from 'material-ui/Checkbox';
import moment from 'moment';

const styles = {
    iconStyle: {
        width: '18px',
        height: '18px',
        marginRight: '5px',
    },
    labelStyle: {
        lineHeight: '16px',
        fontFamily: 'inherit',
        fontSize: '13px',
        color: '#000',
        paddingTop: '1px',
        width: 'auto'
    },
};

const opt_jobFunction = [{ value: "", label: '' }];

class PublicProject extends React.Component {
	constructor(props) {
		super(props);

        this.styles = {
            chip: {
                margin: 4,
                fontSize:'8pt'
            },
            wrapper: {
                display: 'flex',
                flexWrap: 'wrap',
            },
        };

        this.state = {
            opt_jobFunction: [],
            opt_Skills: [],
            skillArr: [],
            have_errors: 0,
            user_profile: null,
            lst_errors: {
                'job_title_error' : '',
                'job_function_error' : '',
                'job_start_error' : '',
                'job_tracking_error' : '',
                'job_type_error' : '',
                'job_employment_error' : '',
                'job_duration_error' : '',

                //details's error
                'job_description_error': '',
                'job_estimate_error': '',
            },
            basics: {
                job_title: '',
                job_function: '',
                job_start: false,
                job_start_date: moment(),
                job_exp_chk: false,
                job_exp: moment(),
            },

            details: {
                job_description: '',
                job_estimate: '',
                job_cost: '',
            },

            preferences: {
                job_desired_skill: [],
            }
        };
	}

    componentWillMount() {
        this.getJobFunction();
    }

	componentDidMount() {}

  	componentWillReceiveProps(nextProps) {}

    getJobFunction() {
        //this.setState({loading: true});
        var url = "/code/apis.php?api=getParams&opt_param=job_function";
        var data = new FormData();
        axios.post(url, data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({ opt_jobFunction: response.data.data });
                }
                return response;
            }).catch(error => {
            this.setState({loading: false});
        });
    }

    handleChange(propertyName, event) {
        const job = this.state.basics;
        if (propertyName == 'job_start_date' || propertyName == 'job_exp') {
            job[propertyName] = event;
        }
        else {
            job[propertyName] = event.target.value;
        }
        this.setState(Object.assign({}, job));
    }

    handleCheck(propertyName, event) {
        const job = this.state.basics;
        job[propertyName] = event.target.checked;
        if (propertyName === 'job_start') {
            job['job_start_date'] = null;
        }
        if (propertyName === 'job_exp_chk') {
            job['job_exp'] = null;
        }
        this.setState(Object.assign({}, job));
    }

    handleJobFunctionChange (event) {
        const job = this.state.basics;
        job['job_function'] = event.value
        this.setState(Object.assign({}, job));
	}

    handleDraft(event) {

    }

    handleSubmit(readyPost, event) {
        const lst_errors = this.state.lst_errors;
        var fields = ['job_title', 'job_function'];

        var have_errors = fields.length;
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];

            if (this.state.basics[field] == '') {
                lst_errors[fields[i]+"_error"] = "Required";
            }
            else {
                lst_errors[fields[i]+"_error"] = "";
                have_errors -= 1;
            }
        }
        var estimate = parseInt(this.state.details['job_estimate'])
        if (estimate <= 0 || estimate > 400 || this.state.details['job_estimate'] === '') lst_errors["job_estimate_error"] = "Required";
        else {
            lst_errors["job_estimate_error"] = "";
            have_errors = have_errors>0?1:0;
        }
        if (this.state.details['job_description'] === '') lst_errors["job_description_error"] = "Required";
        else {
            lst_errors["job_description_error"] = "";
            have_errors = have_errors>0?1:0;
        }

        this.setState({lst_errors: lst_errors});
        this.props.job_state.have_errors = have_errors;

        if (have_errors == 0) {
            this.handlePostSubmit()
        }
    }

    // begin of skill's preferences
    handleSelectSkillChange = (event) => {
        var skillArr = this.state.skillArr;
        var textLable = this.findObjectByKey(this.state.opt_Skills, 'value', event.value);
        skillArr.push(
            <Chip
                key={"profile-skill-item-"+event.value}
                onRequestDelete={this.removeSkill.bind(this, event.value)}
                style={this.styles.chip}
                labelStyle={{fontSize:"8pt"}}
            >
                {textLable}
            </Chip>
        );
        this.setState({skillArr: skillArr});

        const job = this.state.preferences;
        job['job_desired_skill'].push({value: event.value, lable: textLable});
        this.setState(Object.assign({}, job));
    }

    getSkillsOptions = (input, callback) => {
        if(input.length == 0)
        {
            this.setState({opt_Skills:this.state.opt_Skills});
        }
        else {
            var data = new FormData();
            data.append('search', input);
            axios.post('/code/apis.php?api=searchSkill', data, {
                progress: (progressEvent) => {}
            })
                .then(response => {
                    if (response.data.status == 1) {
                        var array = [];
                        var i = 1;
                        for(var item of response.data.data)
                        {
                            var name = item.name_skill ;
                            array.push({ value: item.id_skill, label: name});
                            i++;
                        }
                        this.setState({opt_Skills: array});
                    } else {
                        this.setState({opt_Skills:[]});
                    }
                    return response;
                })
                .catch(error => {
                    callback(null, { options: [] });
                });
        }
    }

    removeSkill = (it) => {
        const job_original = this.state.preferences['job_desired_skill'];
        const job = this.state.preferences;
        job['job_desired_skill'] = [];
        for (var i = 0; i < job_original.length; i++) {
            var value = job_original[i]['value'];
            if (value != it) {
                job['job_desired_skill'].push(job_original[i]);
            }
        }

        this.setState(Object.assign({}, job), () => {
            this.buildSkillArr();
        });
    }

    buildSkillArr = () => {
        var skillArr = [];
        const job = this.state.preferences;
        var job_desired_skill = job['job_desired_skill'];
        for (var i = 0; i < job_desired_skill.length; i++) {
            var value = job_desired_skill[i]['value'];
            var lable = job_desired_skill[i]['lable'];
            skillArr.push(
                <Chip
                    key={"profile-skill-item-"+value}
                    onRequestDelete={this.removeSkill.bind(this, value)}
                    style={this.styles.chip}
                    labelStyle={{fontSize:"8pt"}}
                >
                    {lable}
                </Chip>
            );
        }
        this.setState({skillArr: skillArr});
    }

    findObjectByKey = (array, key, value) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] == value) {
                return array[i]['label'];
            }
        }
        return null;
    }

    // begin of detail's items
    handleChangeDetail = (propertyName, event) => {
        const job = this.state.details;
        job[propertyName] = event.target.value;

        this.setState(Object.assign({}, job));
    }

    handleChangeNumber = (propertyName, evt) => {
        const job = this.state.details;
        let regExpr = /^[0-9\b]+$/;
        let before = job[propertyName];
        let after = evt.target.value;
        if (regExpr.test(after)) before = after;

        job[propertyName] = before;

        this.setState(Object.assign({}, job));
    }

    handlePostSubmit = (event) => {
        const job = this.state.preferences;
        var job_desired_skill = job['job_desired_skill'];
        var job_desired_skill_str = '';
        for (var i = 0; i < job_desired_skill.length; i++) {
            var value = job_desired_skill[i]['value'];
            job_desired_skill_str = job_desired_skill_str + "" + value + ",";
        }

        var job_start_date = this.state.basics.job_start_date != null ? this.state.basics.job_start_date.format("YYYY-MM-DD") : '';
        var job_exp = this.state.basics.job_exp != null ? this.state.basics.job_exp.format("YYYY-MM-DD") : ''

        var params = Object.assign({},
            this.state.basics,
            this.state.details,
            {
                job_desired_skill: job_desired_skill_str,
                job_start_date: job_start_date,
                job_exp: job_exp,
            }
        );

        this.props.router.push({
            pathname: '/business/signup',
            state: params
        })
    }

	render() {
		return (
            <div className="page_course_box box-item clearfix">
                <div className="form-groups row">
                    <div className="col-xs-12">
                        <h3>Project Support On-demand</h3>
                        <div className={"sub-title"}>Describe your needs and we’ll introduce you to interns ready to help</div>
                    </div>
                </div>
                <div className="form-groups row mt15">
                    <label className="col-xs-12 control-label text-left title">Choose a name for your project<font className={this.state.lst_errors.job_title_error != ''?"cls-error has-error":"has-error"}>※</font></label>
                    <div className="col-xs-12">
                        <input
                            name="title"
                            value={this.state.basics.job_title}
                            onChange={this.handleChange.bind(this, 'job_title')}
                            type="text"
                            className="form-control input-md"
                            placeholder="Add Job title"
                        />
                    </div>
                </div>
                <div className="form-group row mt15">
                    <label className="col-xs-12 control-label text-left title">Choose the category that best fits your request<font className={this.state.lst_errors.job_function_error != ''?"cls-error has-error":"has-error"}>※</font></label>
                    <div className="col-xs-12">
                        <Select
                            name="job_function"
                            className="select_box"
                            value={this.state.basics.job_function}
                            options={this.state.opt_jobFunction}
                            onChange={this.handleJobFunctionChange.bind(this)}
                            placeholder="Search Job Function"
                            clearable={false}
                            searchable={false}
                        />
                    </div>
                </div>
                <div className={"form-group row"}>
                    <label className="col-xs-12 control-label text-left title">Tell us more about your project<font className={this.state.lst_errors.job_description_error != ''?"cls-error has-error":"has-error"}>※</font></label>
                    <div className="col-xs-12">
                        <Textarea
                            name="job_description"
                            onChange={this.handleChangeDetail.bind(this, 'job_description')}
                            minRows={6}
                            maxRows={6}
                            className={"form-control input-md"}
                            value={this.state.details.job_description}/>
                    </div>
                </div>
                <div className={"form-groups row mt15"}>
                    <label className="col-xs-12 control-label text-left title">Estimated Time Of Project<font className={this.state.lst_errors.job_estimate_error != ''?"cls-error has-error":"has-error"}>※</font></label>
                    <div className="col-xs-12">
                        <input
                            name="title"
                            value={this.state.details.job_estimate}
                            onChange={this.handleChangeNumber.bind(this, 'job_estimate')}
                            type="text"
                            placeholder={"1-400 hours"}
                            className="form-control input-md text-right w110"
                        />
                    </div>
                </div>
                <div className={"form-groups row mt15"}>
                    <label className="col-xs-12 control-label text-left title">What is your estimated budget?</label>
                    <div className="col-xs-12">
                        <input
                            name="title"
                            value={this.state.details.job_cost}
                            onChange={this.handleChangeNumber.bind(this, 'job_cost')}
                            type="text"
                            className="form-control input-md text-right w110"
                        />
                    </div>
                </div>
                <div className={"form-groups row mt15"}>
                    <label className="col-xs-12 control-label text-left title">Project Start Date</label>
                    <div className="col-xs-12">
                        <Checkbox
                            label="Start ASAP"
                            value="1"
                            checked={this.state.basics.job_start}
                            onCheck={this.handleCheck.bind(this, 'job_start')}
                            className="radioButton"
                            iconStyle={styles.iconStyle}
                            labelStyle={styles.labelStyle}
                        />
                        {this.state.basics.job_start === false ?
                            <DatePicker
                                name="job_start_date"
                                selected={this.state.basics.job_start_date !== '' ? this.state.basics.job_start_date : null}
                                onChange={this.handleChange.bind(this, 'job_start_date')}
                                placeholderText="Set date MM/DD/YY"
                                className="form-control input-md job-calendar"
                                style={{marginTop: '10px', width: '30%'}}
                            />
                            : ''
                        }
                    </div>
                </div>
                <div className={"form-groups row mt15"}>
                    <label className="col-xs-12 control-label text-left title">Project Due Date</label>
                    <div className="col-xs-12">
                        <Checkbox
                            label="Due ASAP"
                            value="1"
                            checked={this.state.basics.job_exp_chk}
                            onCheck={this.handleCheck.bind(this, 'job_exp_chk')}
                            className="radioButton"
                            iconStyle={styles.iconStyle}
                            labelStyle={styles.labelStyle}
                        />
                        {this.state.basics.job_exp_chk === false ?
                            <DatePicker
                                name="job_exp"
                                selected={this.state.basics.job_exp !== '' ? this.state.basics.job_exp : null}
                                onChange={this.handleChange.bind(this, 'job_exp')}
                                placeholderText="Set date MM/DD/YY"
                                className="form-control input-md job-calendar"
                                style={{marginTop: '10px', width: '30%'}}
                            /> : ''
                        }
                    </div>
                </div>
                <div className={"form-groups row mt15"}>
                    <label className="col-xs-12 control-label text-left title">What skills are required?</label>
                    <div className="col-xs-12 mrb-10">
                        Enter up to 5 skills that best describe your project. Interns
                        will use these skills to find projects they are most interested and
                        experienced in.
                    </div>
                    <div className="col-xs-12" style={this.styles.wrapper}>
                        {this.state.skillArr}
                    </div>
                    <div className="col-xs-12 mrb-10">
                        <Select
                            name="job_desired_skill"
                            className="select_box"
                            value={""}
                            options={this.state.opt_Skills}
                            onChange={this.handleSelectSkillChange.bind(this)}
                            placeholder="Search Skills"
                            onInputChange={this.getSkillsOptions.bind(this)}
                            noResultsText="No Skill found"
                            clearable={false}
                        />
                    </div>
                </div>
                <div className={"form-groups row mt15 privacy-block"}>
                    <label className="col-xs-12 control-label text-left title"><img className={"img_logo"} src="/static/img/homeimg/pj/pj-04.png"/>Your privacy is important</label>
                    <div className="col-xs-12 padding-common">
                        By clicking "Continue with Versity" below, you agree to the <a href={"/projectterms"}>Mini-Internship Terms and Conditions</a> and to the
                        sharing of the information you entered on the forms with
                        potential interns. Within 24 hours, you will receive
                        proposals from interns based on your request and Versity
                        profiles. You agree that those interns may contact you via
                        Versity messaging.
                    </div>
                </div>
                <div className={"block-btn"}>
                    <a onClick={this.handleSubmit.bind(this, true)} className="btn_v btn_confirm">Continue with Versity</a>
                </div>
            </div>
		);
	}
}
PublicProject.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(PublicProject));

// const mapStateToProps = function(store) {
//     return {
//         user_profile: store.userState.user
//     };
// };
// export default PublicProject;


/** WEBPACK FOOTER **
 ** ./src/client/app/eappcomponents/commons/job/public-project.js
 **/